import Model from '@ember-data/model';
import ArrayProxy from '@ember/array/proxy';
import ObjectProxy from '@ember/object/proxy';

/**
 * Pojoize an ember data record
 * Relations will be loaded if they are available in the store
 */
export const toPojo = (object, store) => {
  // null | undefined return themselves
  if (object === undefined || object === null) {
    return object;
  }

  // handle array proxys
  if (object instanceof ArrayProxy) {
    return object.toArray().map(r => toPojo(r, store));
  }

  // handle native arrays
  if (Array.isArray(object)) {
    return object.map(e => toPojo(e, store));
  }
  const isValid = object instanceof Model || object instanceof ObjectProxy;
  if (!isValid) {
    throw new Error('Please provide an ember record or record proxy');
  }
  if (object instanceof ObjectProxy) {
    if (!object.content) {
      throw new Error('Ember proxy is empty');
    }
    object = object.content;
  }

  // enforce type
  let modelObject = object;
  const model = store.modelFor(modelObject.constructor.modelName);
  const attributes = model.attributes;
  const relationships = model.relationshipsByName;
  const plain = {};
  attributes.forEach((_meta, name) => {
    const value = modelObject.get(name);
    if (value !== undefined) {
      plain[name] = value;
    }
  });
  relationships.forEach(({
    key,
    kind
  }, name) => {
    if (kind === 'belongsTo') {
      const relationRef = modelObject.belongsTo(key);
      const value = relationRef.value();
      if (value !== null) {
        plain[name] = value.id;
      }
    } else {
      const relationRef = modelObject.hasMany(key);
      const value = relationRef.value();
      if (value !== null) {
        plain[name] = relationRef.ids();
      }
    }
  });
  plain['id'] = object.id;
  return plain;
};